import { patch } from '@core/api/baseApi';
import { UpdateDefaultOrganizationTemplateResponse } from '@core/types/ApiResponses';

const updateDefaultOrganizationTemplate = (
  templateId: string,
): Promise<UpdateDefaultOrganizationTemplateResponse> =>
  patch('/organizations/templates/default', { templateId });

export default updateDefaultOrganizationTemplate;
